import dayjs from 'dayjs'
import 'dayjs/locale/ja'

const changingTime = dayjs('05:30am', 'h:mma')

export const initDeliveryDateRange = () => {
  dayjs.locale('ja')
  let html = ''

  html = `[${dayjs().format('YYYY年M月DD日(ddd)')}～${dayjs()
    .add(15, 'd')
    .format('YYYY年M月DD日(ddd)')}]`

  $('.delivery__range').html(html)
}

export const initMainDeliveryBanner = () => {
  dayjs.locale('ja')
  let note_date = null
  let delivery_date = null

  if (dayjs().isAfter(changingTime)) {
    if (dayjs().day() == 6) {
      // Saturday
      note_date = dayjs().add(2, 'd')
      delivery_date = dayjs().add(5, 'd')
    } else {
      note_date = dayjs().add(1, 'd')
      delivery_date = dayjs().add(3, 'd')
    }
  } else {
    note_date = dayjs()
    delivery_date = dayjs().add(2, 'd')
  }

  // CMS reflection
  if (globalThis.FFJP.array_modified_date.length > 0) {
    for (const row_date of globalThis.FFJP.array_modified_date) {
      if (note_date.isSame(row_date[0], 'day')) {
        delivery_date = dayjs(row_date[1])
      }
    }
  }

  $('.delivery__date').text(`${note_date.format('M月D日(ddd)')} AM5:30`)
  $('.delivery__shortest').text(`最短で${delivery_date.format('M月DD日(ddd)')}`)
}

export const initDeliveryDateCalendar = () => {
  dayjs.locale('ja')
  let html = ''
  let from = 0
  let to = 15

  if (dayjs().isAfter(changingTime)) {
    if (dayjs().day() == 6) {
      // Saturday
      from += 2
      to += 2
    } else {
      from += 1
      to += 1
    }
  }

  for (let i = from; i < to; i++) {
    let date1, date2, date3
    date1 = dayjs().add(i, 'd')

    // Calculate calendar dates
    if (date1.day() == 0) {
      // Sunday
      date2 = dayjs().add(i + 1 + globalThis.FFJP.calendar_misc_lead_time, 'd')
      date3 = dayjs().add(
        i + 1 + globalThis.FFJP.calendar_furniture_lead_time,
        'd'
      )
    } else {
      date2 = dayjs().add(i + globalThis.FFJP.calendar_misc_lead_time, 'd')
      date3 = dayjs().add(i + globalThis.FFJP.calendar_furniture_lead_time, 'd')
    }

    // CMS reflection
    if (globalThis.FFJP.array_modified_date.length > 0) {
      for (const row_date of globalThis.FFJP.array_modified_date) {
        if (date1.isSame(row_date[0], 'day')) {
          date2 = dayjs(row_date[1])
          date3 = dayjs(row_date[2])
        }
      }
    }

    html += `<tr>
            <th>${dateToString(date1)}</th>
                <td>${dateToString(date2)}</td>
                <td>${dateToString(date3)}</td>
            </tr>`
  }

  $('.table-delivery tbody').html(html)
}

const dateToString = (date) => {
  let dateS = ''

  if (date.day() == 6) {
    dateS = `<strong>${date.format('M/DD(ddd)')}</strong>`
  } else if (date.day() == 0) {
    dateS = `<span>${date.format('M/DD(ddd)')}</span>`
  } else {
    dateS = `${date.format('M/DD(ddd)')}`
  }

  return dateS
}
